import * as React from "react";
import { Provider } from "mobx-react";
import { store } from "public@store/index";

const AppStore = { store };
export default class SignInDetailsDialog extends React.Component<any, any> {
  public render() {
    return <Provider {...AppStore}>{this.props.children}</Provider>;
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/provider/index.tsx